import { CloseOutlined } from "@ant-design/icons"
import { Form, Input, Modal, Select, FormInstance, FormProps } from "antd"
import { useEffect, useRef, useState } from "react"
import { getCLCarLines, IRelative } from "../../../../../api/selectOption/selectOptionsApi"
import { editTypeVehicle, ITypeVehicle, ITypeVehicleEditV2 } from "../../../../../api/typeVehicle/typeVehicleApi"
import useThrottle from "../../../../../hook/useThrottle"
import { useForm } from "antd/es/form/Form"
import useToast from "../../../../../hook/useToast"
import './style.scss'
import { ISelectOption } from "../../../../../api/selectOptions/selectOptionsApi"
import { fommatSelectOption } from "../../../../../until"
interface ModalProps {
  isOpen: boolean
  infoTypeVehicle?: ITypeVehicle
  // sLCategoryCar: ICarCompany[]
  onSubmitFormModal?: (iSsuccess: boolean, errorMessage?: string) => void;
  closeModal: () => void
}
const ModalEditCatecoryCar: React.FC<ModalProps> = ({
  isOpen, infoTypeVehicle,
  onSubmitFormModal, closeModal
}) => {


  const [form] = useForm();
  const inputRef = useRef<FormInstance>(null);

  const [cLCarLines, setCLCarLines] = useState<ISelectOption[]>([])

  const gCLCarLines = async () => {
    const result = await getCLCarLines()
    if (result?.status) {
      setCLCarLines(fommatSelectOption(result.data))
    }
  }

  const submitForm = () => {
    if (inputRef.current) {
      inputRef.current.submit();
    }
  };

  const onFinish: FormProps["onFinish"] = async (values) => {
    if (!infoTypeVehicle) return
    const { idCarLine, code, title } = values

    const result = await editTypeVehicle(
      infoTypeVehicle.id, title, code, idCarLine
    )
    if (result?.status) {
      onSubmitFormModal?.(true, result.message)
    } else {
      onSubmitFormModal?.(false, result.message)
    }
  }

  useEffect(() => {
    if (isOpen) {
      if (!cLCarLines.length)
        gCLCarLines()

      if (infoTypeVehicle) {
        const { code, carLineId, title } = infoTypeVehicle
        form.setFieldsValue({
          "idCarLine": carLineId,
          "code": code,
          "title": title
        })
      }
    } else {
      form.resetFields()
    }

  }, [isOpen])
  return (
    <Form
      className="form-add-vehicle"
      form={form}
      ref={inputRef}
      onFinish={onFinish}
      initialValues={{ remember: true }}
    >
      <Modal
        title={<div className="bg-FCFCFD d-flex justify-betweeen align-center py-4 px-6 w-full border-b-F0F0F0">
          <span className="text-base text-344054 fw-500 font-medium">
            Chỉnh sửa loại xe
          </span>
          <CloseOutlined className="text-base text-8B8B8B"
            onClick={closeModal}
          />
        </div>}
        open={isOpen}
        onCancel={closeModal}
        centered
        className="w-modal modal-content-category ant-modal-size"
        closeIcon={false}
        footer={
          <div className="bg-FCFCFD d-flex justify-betweeen align-center py-2 px-6 w-full border-t-F0F0F0">
            <span className="text-sm text-98A2B3 cursor-pointer"
              onClick={closeModal}
            >
              Huỷ
            </span>
            <button className="text-white text-sm bg-096DD9 border-none shadow-btn-save rounded-2 h-8 px-15-px"
              onClick={submitForm}>
              Lưu
            </button>
          </div>
        }
      >
        <div className="d-flex flex-column px-6 py-2 gap-4">
          <div className="d-flex flex-column gap-1">
            <Form.Item
              label={<span className="">Dòng xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              className="m-none-form-item text-explan text-label"
              layout="vertical"
              name="idCarLine"
            >
              <Select
                allowClear
                options={cLCarLines}
                disabled
              />
            </Form.Item>
          </div>
          <div className="d-flex flex-column gap-1">
            <div className="d-flex flex-column gap-1">
              <Form.Item
                label={<span className="">Mã loại xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}

                layout="vertical"
                name="code"
                rules={[{ required: true, message: 'Nhập mã loại xe!' }]}
                className="m-none-form-item text-explan text-label"
              >
                <Input
                  placeholder="Mã loại xe"
                  className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
                />
              </Form.Item>
            </div>
          </div>
          <div className="d-flex flex-column gap-1">
            <Form.Item
              label={<span className="">Loại xe<span className="pl-1" style={{ color: 'red' }}>*</span></span>}
              layout="vertical"
              name="title"
              rules={[{ required: true, message: 'Nhập loại xe!' }]}
              className="m-none-form-item text-explan text-label"
            >
              <Input
                placeholder="Loại xe"
                className="bg-FCFCFD border-F2F4F7 text-sm rounded-2  font-regular  input-custom  h-8"
              />
            </Form.Item>
          </div>

        </div>
      </Modal>
    </Form>
  )
}
export default ModalEditCatecoryCar
